<template>
  <div class="col">
    <multiselect
      v-show="filteredProgramOptions.length"
      v-model="programSelected"
      :options="filteredProgramOptions"
      :placeholder="$ml.get('selectProgram')"
      :searchable="true"
      label="name"
      :close-on-select="true"
      :show-labels="false"
      :allow-empty="false"
      :preselect-first="true"
      :multiple="false"
    >
    </multiselect>
    <div
      v-if="listProgramSelected.length"
      class="d-flex align-items-center"
      style="gap: 5px; flex-wrap: wrap"
    >
      <div
        v-for="(program, index) in listProgramSelected"
        :key="index"
        class="custom-tag mt-2"
      >
        <span>{{ program.name }}</span>
        <span class="close" @click="removeProgram(program)">x</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "selectProgram",
  props: ["listProgram", "programSelectedUser"],
  data() {
    return {
      listProgramSelected: [],
      programSelected: "",
    };
  },
  watch: {
    programSelected() {
      if (this.programSelected) {
        this.listProgramSelected = [
          ...this.listProgramSelected,
          this.programSelected,
        ];
        this.sendData();
      }

      this.programSelected = "";
    },
  },
  computed: {
    filteredProgramOptions() {
      let filterIds = this.listProgramSelected.map((it) => it._id);
      return this.listProgram.filter((item) => !filterIds.includes(item._id));
    },
  },
  methods: {
    removeProgram(program) {
      this.listProgramSelected = this.listProgramSelected.filter(
        (it) => it._id != program._id,
      );
      this.sendData();
      this.programSelected = "";
    },
    sendData() {
      this.$emit("getPrograms", {
        listPrograms: this.listProgramSelected,
      });
    },
  },
  mounted() {
    if(this.programSelectedUser?.length){
        this.listProgramSelected = this.programSelectedUser;
        this.programSelected = null;
      }
  },
};
</script>
<style scoped>
.custom-tag {
  position: relative;
  border-radius: 5px;
  background: #fff;
  border: 1px solid #9c27b0;
  color: #9c27b0;
  padding: 2px 25px 2px 2px;
}
.close {
  cursor: pointer;
  color: #e91e63;
  font-weight: 500;
  position: absolute;
  font-size: 1rem;
  right: 5px;
  top: 0px;
}
.close:hover {
  color: #fd0d5d;
}
</style>
